export const startWithHttp = (url: string) => {
  const reg = /^http(s)?:\/\//;
  return reg.test(url);
}